module.exports = __webpack_public_path__ + "static/media/duckCreekLogo.f8b3a9bd.png";